import angular from 'angular';
import FuelFormController from './fuel-form.controller';

import './fuel-form.styles.scss';

export default angular.module('autoboard.fuelForm', [])
  .controller('FuelFormController', FuelFormController)
  .name;
